import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Store } from "@ngrx/store";
import { PermissionStates } from "../../modules/permission/permission-controller/root";
import { UserPermInquirySelectors } from "../../modules/permission/user-permissions-inquiry-controller/selectors";
import { SessionSelectors } from "../../modules/session/session-controller/selectors";
import { SessionStates } from "../../modules/session/session-controller/states";
import { DropDownService } from "../../services/drop-down-service";
import { AppConfig } from "../../visa";
import { Observable, of, ReplaySubject } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import { SubSink } from "subsink2";
@Component({
  selector: "app-location-to",
  templateUrl: "./location-to.component.html",
  styleUrls: ["./location-to.component.css"],
})
export class LocationToComponent implements OnInit {
  @Input() locationControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() label: string;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredLocations$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  locations: any[] = [];

  @ViewChild("locationInput") locationInput: ElementRef<HTMLInputElement>;
  locationTargets: string[] = [];
  rowData: any = [];
  key = "location";

  constructor(
    private dropDownService: DropDownService,
    private readonly permissionStore: Store<PermissionStates>,
    private readonly sessionStore: Store<SessionStates>
  ) {}

  ngOnInit(): void {
    this.viewModelStore
      .select(this.ColumnViewSelectors.selectAdvanceSearch_LocationTo_Field)
      .subscribe((data) => {
        this.locations = data;
      });

    this.sessionStore
      .select(SessionSelectors.selectDropDownRowData)
      .subscribe((resolved) => {
        this.rowData = resolved
          ? resolved[this.key]
            ? resolved[this.key]
            : []
          : [];
        if (this.rowData.length === 0) {
          this.getRowData();
        } else {
          this.filteredLocations$.next(this.rowData.slice());
        }
      });

    this.locationControl.valueChanges
      .pipe(
        debounceTime(300), // wait for 300ms pause in events
        distinctUntilChanged(), // ignore if the value hasn't changed
        switchMap((value) => {
          // Implement your filtering logic here and return the filtered locations
          return this.filterLocations(value);
        })
      )
      .subscribe((filteredLocations) => {
        this.filteredLocations$.next(filteredLocations);
      });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our branch
    if (value) {
      this.locations.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.locationControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_LocationToField({
        locations: this.locations,
      })
    );
  }

  remove(branch: string): void {
    const index = this.locations.indexOf(branch);

    if (index >= 0) {
      this.locations.splice(index, 1);
    }

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_LocationToField({
        locations: this.locations,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.locations.push(event.option.value);
    this.locationInput.nativeElement.value = "";
    this.locationControl.setValue(null);
  }

  getRowData() {
    let formData = {
      limit: null,
      orderBy: "code",
      order: "ASC",
    };

    this.dropDownService
      .get("location", formData, AppConfig.apiVisa)
      .subscribe((resolved) => {
        this.rowData = resolved.data;
        //fill the drop down
        this.filteredLocations$.next(this.rowData.slice());
      });
  }

  filterLocations(value: string): Observable<any[]> {
    return of(
      this.rowData.filter(
        (location) =>
          location.name.toLowerCase().includes(value.toLowerCase()) ||
          location.code.toLowerCase().includes(value.toLowerCase())
      )
    );
  }

  optionClicked(event: Event, location: any) {
    event.stopPropagation();
    this.toggleSelection(location);
  }

  toggleSelection(location: any) {
    console.log(location);
    location.selected = !location.selected;
    this.locationInput.nativeElement.value = "";
    if (location.selected) {
      this.locations.push(location);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_LocationToField({
          locations: this.locations,
        })
      );
    } else {
      const i = this.locations.findIndex(
        (value) => value.guid === location.guid
      );
      this.locations.splice(i, 1);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_LocationToField({
          locations: this.locations,
        })
      );
    }
  }

  onReset() {
    this.locations = [];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
